// Cover picker on the print edition page. Selecting a cover dims the
// others and updates the readout in the purchase bar.

export default function coverPicker() {
    const covers = Array.from(document.querySelectorAll('.issue-cover'));
    if (covers.length < 2) return;

    const readout = document.querySelector('[data-cover-readout]');

    function select(chosen) {
        covers.forEach((cover) => {
            cover.setAttribute('aria-pressed', String(cover === chosen));
        });
        if (readout) {
            readout.textContent = chosen.getAttribute('data-cover-name') || '';
        }
    }

    covers.forEach((cover) => {
        cover.addEventListener('click', () => select(cover));
    });

    select(covers[0]);
}
